import React, {
  useState,
  useEffect
} from "react";

//components
import PresetList from "../components/PresetList";
import PresetItem from "../components/PresetItem";
import PresetInfo from "../components/PresetInfo";
import LoadingCenter from "../components/LoadingCenter";
import PresetListHeader from "../components/PresetListHeader";

//api
import api from "../services/api";

//auth
import {
  useAuth
} from "../providers/auth";

//Sweet alert
import Swal from "sweetalert2";
import NewButton from "../components/NewButton";
import { useNavigate } from "react-router-dom";

export const Presets = () => {
  const [presets, setPresets] = useState([]);
  const [loading, setLoading] = useState(false);

  let navigate = useNavigate();

  //auth
  const { user } = useAuth();

  const authorization = { headers: { "Authorization": "Bearer " + user.token } };

  async function fetchPresets() {
    setLoading(true);

    try {
      const response = await api.get("/presets/admins", authorization);

      setPresets(response.data);
    } catch (error) {
      let icon = "error";
      let title = "Ocorreu um erro";
      let text = "Erro interno do servidor.";

      openAlert(icon, title, text);
    } finally {
      setLoading(false);
    }
  };

  function onDelete(command) {
    let filteredPresets = presets.filter(preset => preset.command !== command);
    setPresets(filteredPresets);
  };

  function onNewPreset() {
    navigate("/utils/presets/new");
  }

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer)
      toast.addEventListener("mouseleave", Swal.resumeTimer)
    }
  });

  const openAlert = (icon, title, text) => {
    Toast.fire({
      icon,
      title,
      text
    });
  };

  useEffect(() => {
    fetchPresets();
  }, []);

  const hasPresets = presets.length ?
    presets.map(preset => <PresetItem key={preset.id} preset={preset} onDelete={onDelete} />)
    : <PresetInfo onClick={fetchPresets} />;

  const isLoading = loading ? <LoadingCenter /> : hasPresets;

  return (
    <div className="u-d-flex u-flex-column u-align-center u-justify-center u-mt-40">
      <div className="u-w-900 u-d-flex u-justify-end">
        <NewButton variant="success" block="inline-block" onClick={onNewPreset}>
          Adicionar novo preset
        </NewButton>
      </div>
      <div className="fk-table">
        <PresetList>
          <PresetListHeader />
          {isLoading}
        </PresetList>
      </div>
    </div>
  );
}

export default Presets;